import $ from 'jquery';

export const switchModalScreen = (modalScreenSelector) => {
    $('.modal-screen.active').removeClass('active');
    $(modalScreenSelector).addClass('active');
};

export const clickSwitchTrigger = () => {
    $('.btn-trigger').click(function () {
        switchModalScreen('#' + $(this).attr('data-screen'));
    });
};
